import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { HlmLabelDirective } from '@spartan-ng/ui-label-helm';
import { HlmCheckboxComponent } from '@spartan-ng/ui-checkbox-helm';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SharedModule } from '../../shared.module';
import { FileUploadComponent } from '@apps/landing/src/app/shared/components/file-upload/file-upload.component';
import { ContactFormModel } from '@apps/landing/src/app/shared/models/contact-form.model';
import { onKeyDown } from '@apps/landing/src/app/shared/utils/keyboard-event.util';
import { HlmSpinnerComponent } from '@spartan-ng/ui-spinner-helm';
import { ComponentsModule } from '@libs/ui/components/components.module';
import { SpartanSelectComponent } from '@apps/landing/src/app/shared/components/spartan-select/spartan-select.component';

@Component({
  selector: 'app-form-card',
  imports: [
    HlmLabelDirective,
    HlmCheckboxComponent,
    HlmButtonDirective,
    ReactiveFormsModule,
    SharedModule,
    FileUploadComponent,
    HlmSpinnerComponent,
    ComponentsModule,
    SpartanSelectComponent,
  ],
  standalone: true,
  templateUrl: './form-card.component.html',
})
export class FormCardComponent {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() formGroup!: FormGroup;
  @Input() fields: ContactFormModel[];
  @Input() multipleDocs: boolean = false;
  @Input() loading: boolean;
  @Output() formSubmit = new EventEmitter<void>();
  @ViewChild(FileUploadComponent) fileUploadComponent!: FileUploadComponent;

  protected readonly onKeyDown = onKeyDown;
  protected readonly Validators = Validators;

  protected onSubmit() {
    if (this.formGroup.valid) {
      this.formSubmit.emit();
    } else {
      this.formGroup.markAllAsTouched();
    }
  }

  clearFileUpload() {
    this.fileUploadComponent?.clear();
  }
}
